import { render } from "./EditVIPProfile.vue?vue&type=template&id=207ff984&scoped=true"
import script from "./EditVIPProfile.vue?vue&type=script&lang=js"
export * from "./EditVIPProfile.vue?vue&type=script&lang=js"

import "./EditVIPProfile.vue?vue&type=style&index=0&id=207ff984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207ff984"]])

export default __exports__